import { styled } from '@nykaa/ui-components';
import { BASE_GUTTER_SPACE } from 'shared/styles/base';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  height: 100vh;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
  padding: ${({ theme }) =>
    `58px ${theme.spacing.spacing10} ${theme.spacing.spacing10} ${theme.spacing.spacing10}`};

  &::after {
    content: '';
    flex: auto;
  }
`;

export const ImageItem = styled.div`
  padding: 0;
  border-radius: ${({ theme }) => theme.borders.radius10};
  width: calc(33.3333% - ${BASE_GUTTER_SPACE}px);
  margin: ${({ theme }) => theme.spacing.spacing20};
  display: flex;

  &:focus {
    outline: none;
  }

  .reviewImage {
    object-fit: cover;
  }
`;
